"use strict";

// Copyright 2015-2020 The MathWorks, Inc.
define(['./EndPointsManager'], function (EndPointsManager) {
  var _instance = null;

  var getInstance = function getInstance() {
    if (_instance === null) {
      _instance = new EndPointsManager();
    }

    return _instance;
  };

  return getInstance();
});
//# sourceMappingURL=RemoteEndPointsManager.js.map
